import { useCall } from "@/hooks/useCall/useCall";
import { useGetPlaybookResults } from "@/hooks/useGetPlaybookResults";
import { Flex } from "@aircall/tractor";
import { Loader } from "@dashboard/library";
import { t } from "i18next";
import { PlaybookResultsForm } from "../PlaybookResultsForm/PlaybookResultsForm";
import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";

export function SectionPlaybook() {
  const { call } = useCall();
  const callId = call?.id ?? undefined;
  const { playbookResult, loading } = useGetPlaybookResults(callId);

  if (!callId) {
    return null;
  }

  if (loading) {
    return (
      <Flex h="70px" w="100%" alignItems="center" justifyContent="center">
        <Loader />
      </Flex>
    );
  }

  if (!playbookResult) {
    return null;
  }

  const title = `${playbookResult.name} ${t("call_context.playbook_summary")}`;

  return (
    <SectionLayout data-test="playbook-section">
      <Flex gap="xxs" alignItems="center">
        <SectionHeader>{title}</SectionHeader>
      </Flex>

      <Flex
        bg="surface-background"
        borderRadius="sm"
        p="s"
        flexDirection="column"
      >
        <PlaybookResultsForm playbookResult={playbookResult} />
      </Flex>
    </SectionLayout>
  );
}
